<template>
	<div class="gb-page blog-article-page">
		<HeadNav selectedLanguage="en" page="blog" />

		<section v-if="article" class="blog-article-hero">
			<div class="blog-article-inner">
				<p class="blog-article-date">{{ article.date }}</p>
				<h1>{{ article.title }}</h1>
				<img class="blog-article-poster" :src="article.poster" :alt="article.title" />
			</div>
		</section>

		<article v-if="article" class="gb-article blog-article-body">
			<template v-for="(block, index) in article.blocks">
				<h2 v-if="block.type === 'h2'" :key="`h2-${index}`">{{ block.text }}</h2>
				<h3 v-else-if="block.type === 'h3'" :key="`h3-${index}`">{{ block.text }}</h3>
				<p v-else-if="block.type === 'p' && block.html" :key="`p-html-${index}`" v-html="block.html"></p>
				<p v-else-if="block.type === 'p'" :key="`p-${index}`">{{ block.text }}</p>
				<ul v-else-if="block.type === 'ul'" :key="`ul-${index}`">
					<li v-for="(item, itemIndex) in block.items" :key="itemIndex" v-html="formatListItem(item)"></li>
				</ul>
			</template>
		</article>

		<section v-if="relatedArticles.length" class="blog-related">
			<div class="blog-related-inner">
				<h2>More GB WhatsApp Guides</h2>
				<div class="blog-related-grid">
					<a v-for="item in relatedArticles" :key="item.name" class="blog-related-card" :href="item.url">
						<img :src="item.poster" :alt="item.title" />
						<span>{{ item.title }}</span>
					</a>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import '@/css/base.scss'
import '@/css/index.scss'
import '@/css/gbappss.scss'
import blogDoc from '@/documents/blogs.js'
import HeadNav from '@/components/HeadNav.vue'

export default {
	name: 'BlogArticle',
	components: { HeadNav },
	computed: {
		article() {
			return blogDoc.articles.find((item) => item.name === this.$route.name)
		},
		relatedArticles() {
			if (!this.article) return []
			return blogDoc.articles.filter((item) => item.name !== this.article.name).slice(0, 2)
		},
	},
	methods: {
		escapeHtml(value) {
			return String(value)
				.replace(/&/g, '&amp;')
				.replace(/</g, '&lt;')
				.replace(/>/g, '&gt;')
				.replace(/"/g, '&quot;')
				.replace(/'/g, '&#39;')
		},
		formatListItem(item) {
			const text = this.escapeHtml(item)
			const colonIndex = text.indexOf(':')
			if (colonIndex === -1) return text
			return `<strong>${text.slice(0, colonIndex + 1)}</strong>${text.slice(colonIndex + 1)}`
		},
	},
}
</script>

<style lang="scss" scoped>
.blog-article-page {
	background: #fff;
}

.blog-article-hero {
	background: linear-gradient(180deg, #f7fdf9 0%, #ffffff 100%);
	border-bottom: 1px solid #d7ebe5;
}

.blog-article-inner {
	width: min(980px, 88vw);
	margin: 0 auto;
	padding: 34px 0 28px;
	text-align: center;
}

.blog-article-date {
	margin: 0 0 10px;
	padding: 0;
	color: #64748b;
	font-size: 14px;
	font-weight: 700;
}

.blog-article-inner h1 {
	max-width: 820px;
	margin: 0 auto 24px;
	color: #0f172a;
	font-size: clamp(2rem, 4vw, 3.1rem);
	font-weight: 800;
	line-height: 1.12;
}

.blog-article-poster {
	display: block;
	width: 100%;
	max-height: 360px;
	object-fit: cover;
	border-radius: 8px;
	border: 1px solid #d7ebe5;
	background: #f0fdf4;
}

.blog-article-body {
	padding-top: 30px;
}

.blog-article-body ul {
	list-style: none;
	padding-left: 0;
}

.blog-article-body li strong {
	color: #1f2937;
	font-weight: 800;
}

.blog-related {
	background: #f7fdf9;
	border-top: 1px solid #d7ebe5;
	padding: 34px 0 46px;
}

.blog-related-inner {
	width: min(980px, 88vw);
	margin: 0 auto;
}

.blog-related h2 {
	margin: 0 0 18px;
	color: #0f172a;
	font-size: 1.5rem;
	font-weight: 800;
}

.blog-related-grid {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 18px;
}

.blog-related-card {
	display: grid;
	grid-template-columns: 132px minmax(0, 1fr);
	gap: 14px;
	align-items: center;
	padding: 12px;
	background: #fff;
	border: 1px solid #d7ebe5;
	border-radius: 8px;
	color: #0f172a;
	font-weight: 800;
	line-height: 1.35;
	text-decoration: none;
}

.blog-related-card:hover {
	border-color: #86efac;
	color: #15803d;
}

.blog-related-card img {
	width: 132px;
	height: 82px;
	object-fit: cover;
	border-radius: 6px;
}

@media (max-width: 768px) {
	.blog-article-inner {
		padding: 24px 0 22px;
	}

	.blog-article-inner h1 {
		font-size: 2rem;
	}

	.blog-article-poster {
		max-height: 260px;
	}

	.blog-related-grid {
		grid-template-columns: 1fr;
	}

	.blog-related-card {
		grid-template-columns: 96px minmax(0, 1fr);
	}

	.blog-related-card img {
		width: 96px;
		height: 70px;
	}
}
</style>
